import { Apartment } from '../types/building';

/**
 * Gibt die korrekte Bezeichnung für eine Wohnung basierend auf dem Bereichstyp zurück
 */
export const getApartmentLabel = (apartment: Apartment): string => {
  return apartment.areaType === 'cellar' ? 'Kellerbereich' : 'WE';
};